var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 48.106,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.761.004c-.767 12.115-14.12 12.925-22.148 20.928-6.109 6.089-6.863 16.463 2.1 21.716 2.266-1.127-2.025-9.767 2.8-13.553-2.116 4.6 5.63 11.584.41 19.014 6.9 0 9.4-6.7 9-9.93-.313-2.557 2.5-1.712 1.913.163-.948 3.017 3.343 3.682 6.1 2.7 5.147-1.826 2.252 1.662 3.774.844 6.4-3.438 6.323-13.242 3.256-17.242-.174 4.131-8.913 2.663-8.77 9.13-1.193-6.809 7.316-10.053 5.434-16.658-1.965 4.24-17.368 6.278-16.96 17.891C9.246 22.337 33.211 17.944 26.761.004z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.5d9b5b1129bf84c0a60031558bd7d48c.svg";
export { ForwardRef as ReactComponent };